<template>
    <component :is="warehouseData === undefined ? 'div' : 'b-card'">

        <!-- Alert: No item found -->
        <b-alert
            variant="danger"
            :show="warehouseData === undefined"
        >
            <h4 class="alert-heading">Error al obtener los datos del almacén</h4>
            <div class="alert-body">
                No se encontró ningún almacén con este id. Verificar en la
                <b-link
                    class="alert-link"
                    :to="{ name: 'warehouses'}"
                >
                    Lista de almacenes
                </b-link>
                para buscar otro almacén.
            </div>
        </b-alert>

        <b-tabs
            v-if="warehouseData"
            pills
        >

            <!-- Tab: Information -->
            <b-tab>
                <template #title>
                    <feather-icon
                        icon="InfoIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Información</span>
                </template>

                <warehouse-form
                    class="mt-2 pt-75"
                    submit-label="ACTUALIZAR"
                    :warehouse-data="warehouseData"
                    :saving="saving"
                    @submit="updateWarehouse"
                />
            </b-tab>

        </b-tabs>
    </component>
</template>

<script>

    import { BAlert, BCard, BLink, BTab, BTabs } from 'bootstrap-vue';
    import { onUnmounted, ref } from '@vue/composition-api';
    import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
    import warehouseStoreModule from '../warehouseStoreModule';
    import WarehouseForm from '../WarehouseForm.vue';
    import router from '@/router';
    import store from '@/store';

    export default {
        components: {
            BTab,
            BTabs,
            BCard,
            BAlert,
            BLink,

            WarehouseForm
        },
        setup() {
            const warehouseData = ref(null);
            const saving = ref(false);

            const WAREHOUSE_APP_STORE_MODULE_NAME = 'app-warehouse';

            // Register module
            if (!store.hasModule(WAREHOUSE_APP_STORE_MODULE_NAME)) store.registerModule(WAREHOUSE_APP_STORE_MODULE_NAME, warehouseStoreModule);

            // UnRegister on leave
            onUnmounted(() => {
                if (store.hasModule(WAREHOUSE_APP_STORE_MODULE_NAME)) store.unregisterModule(WAREHOUSE_APP_STORE_MODULE_NAME)
            });

            store.dispatch('app-warehouse/fetchWarehouse', { id: router.currentRoute.params.id })
                .then(response => {
                    warehouseData.value = response.data;
                })
                .catch(() => {
                    warehouseData.value = undefined;
                });

            return {
                warehouseData,
                saving
            }
        },
        methods: {
            updateWarehouse(data) {

                this.saving = true;

                this.$store.dispatch('app-warehouse/updateWarehouse', {
                    id: this.$route.params.id,
                    warehouseData: data
                })
                    .then(response => {
                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: response.data.message,
                                icon: 'CheckIcon',
                                variant: 'success'
                            }
                        });
                    })
                    .catch(err => {

                        const message = err.response && err.response.data.message ?
                            err.response.data.message : 'Error al actualizar el almacén.';

                        this.$toast({
                            component: ToastificationContent,
                            props: {
                                title: message,
                                icon: 'AlertTriangleIcon',
                                variant: 'danger'
                            }
                        });

                    })
                    .finally(() => {
                        this.saving = false;
                    });
            }
        }
    }

</script>
